import React, { useState } from 'react';
import { Mail, User, Briefcase, Award } from 'lucide-react';

const BioForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    company: '',
    role: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.email) {
      setErrors({ email: 'Email is required' });
      return;
    }
    
    if (!validateEmail(formData.email)) {
      setErrors({ email: 'Please enter a valid email' });
      return;
    }

    onSubmit(formData);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'linear-gradient(135deg, #0A0512 0%, #11081A 100%)' }}>
      <div className="w-full max-w-xl">
        <div className="glass-card p-8 md:p-12 fade-in">
          {/* Header */}
          <div className="mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-3">
              Enter Your Info
            </h2>
            <p className="text-[#A19EB5] leading-relaxed">
              We need your email to save your predictions. Everything else is optional.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email - Required */}
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-[#A64DF7] mb-2 font-semibold">
                Email Address *
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6E6885]" />
                <input
                  data-testid="email-input"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@company.com"
                  className="w-full pl-12 pr-4"
                  required
                />
              </div>
              {errors.email && (
                <p className="mt-2 text-sm text-[#FF6B6B]">{errors.email}</p>
              )}
            </div>

            {/* Name - Optional */}
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-[#A19EB5] mb-2">
                Name (Optional)
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6E6885]" />
                <input
                  data-testid="name-input"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Jane Doe"
                  className="w-full pl-12 pr-4"
                />
              </div>
            </div>

            {/* Company - Optional */}
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-[#A19EB5] mb-2">
                Company (Optional)
              </label>
              <div className="relative">
                <Briefcase className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6E6885]" />
                <input
                  data-testid="company-input"
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Acme Inc."
                  className="w-full pl-12 pr-4"
                />
              </div>
            </div>

            {/* Role - Optional */}
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-[#A19EB5] mb-2">
                Role (Optional)
              </label>
              <div className="relative">
                <Award className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#6E6885]" />
                <input
                  data-testid="role-input"
                  type="text"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  placeholder="Software Engineer"
                  className="w-full pl-12 pr-4"
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              data-testid="continue-button"
              type="submit"
              className="purple-btn w-full mt-8"
            >
              Continue to Betting
            </button>
          </form>

          {/* Footer Note */}
          <p className="mt-6 text-xs text-center text-[#6E6885]">
            Your data is only used for this prediction pool and won't be shared.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BioForm;
